import { createStore } from 'vuex'
import {schema, normalize} from "normalizr";

const articleConfigGroupItems = new schema.Entity('articleConfigGroupItems', {}, {
  idAttribute: 'kKonfigitem',
});

const articleConfigGroup = new schema.Entity('articleConfigGroups', {
  oItem_arr: [articleConfigGroupItems],
}, {
  idAttribute: 'kKonfiggruppe',
});

export default createStore({
  state: {
    sortOrders: {
      articleConfigGroups: [],
    },
    articleConfigGroups: {},
    articleConfigGroupItems: {},
    currentConfiguration: {
      configurationItems: [],
      cartMultiplier: 1,
    },
    article: {},
    jtlToken: '',
    options: {},
    configTypes: {
      CONFIG_GROUP_TYPE_CHECKBOX: null,
      CONFIG_GROUP_TYPE_RADIO: null,
      CONFIG_GROUP_TYPE_DROPDOWN: null,
      CONFIG_GROUP_TYPE_DROPDOWN_MULTI: null,
    },
  },
  mutations: {
    REMOVE_ENTITIES(state, entityData) {
      entityData.ids.forEach((id) => {
        delete state[entityData.type][id];
      });
    },

    GENERIC_UPDATE_ENTITIES(state, entityData) {
      const normalizedEntities = normalize(entityData.entities, entityData.type);

      state['sortOrders'][entityData.entityName] = [...normalizedEntities.result];
      for(let type in normalizedEntities.entities) {
        for(let entity in normalizedEntities.entities[type]) {

          const oldState = state[type][entity] || {};
          state[type][entity] = {...oldState, ...normalizedEntities.entities[type][entity]};
        }
      }
    },

    UPDATE_CURRENT_CONFIGURATION_ITEM(state, data) {
      const oldState = state['currentConfiguration'];
      state['currentConfiguration'] = {
        ...oldState,
        configurationItems: {
          ...oldState.configurationItems,
          [data.id]: data.quantity,
        }
      }
    },

    SET_ARTICLE(state, data) {
      state.article = {...data};
    },

    SET_JTL_TOKEN(state, token) {
      state.jtlToken = token;
    },

    SET_OPTIONS(state, options) {
      state.options = options;
    },

    SET_CONFIG_TYPES(state, configTypes) {
      state.configTypes = {...configTypes};
    },

    UPDATE_CART_MULTIPLIER(state, value) {
      state.currentConfiguration.cartMultiplier = value;
    }
  },
  actions: {
    injectProductConfigDetails({commit}, data) {
      commit('GENERIC_UPDATE_ENTITIES', {
        entityName: 'articleConfigGroups',
        entities: data,
        type: [articleConfigGroup],
      });
    },
    updateConfigurationItem({commit}, data) {
      commit('UPDATE_CURRENT_CONFIGURATION_ITEM', data);
    },
  },
  getters: {
    getConfigGroupForConfigItem(state) {
      return (id) => {
        return Object.values(state.articleConfigGroups).find(({oItem_arr}) => {
          return oItem_arr.includes(Number.parseInt(id, 10));
        });
      }
    },
    getConfiguredItems(state, getters) {
      const tmp = [];

      if(state.article.name) {
        tmp.push({
          isArticle: true,
          name: state.article.name,
          price: state.article.price,
          netPrice: state.article.netPrice
        });
      }

      tmp.push(...Object.entries(state.currentConfiguration.configurationItems)
        .map((i) => {
          return {id: i[0], quantity: i[1]};
        })
        .filter((i) => i.quantity > 0)
        .map((i) => {
          const item = state.articleConfigGroupItems[i.id]
          return {
            articleId: item.kArtikel,
            id: i.id,
            name: item.cName,
            basePrice: item.fPreis[0],
            price: item.fPreis[0] * i.quantity, // brutto price
            quantity: i.quantity,
            configGroupId: getters.getConfigGroupForConfigItem(i.id).kKonfiggruppe,
          }
        }),
      );

      return tmp;
    },
    getOfferDetails(state, getters) {
      return {
        article: state.article.id,
        mainQuantity: state.currentConfiguration.cartMultiplier,
        configuredItems: getters.getConfiguredItems
          .filter(({isArticle}) => !isArticle)
          .map((ci) => ({id: ci.articleId, quantity: ci.quantity})),
      }
    }
  }
})
